import default_profile_pic from '../images/default_profile_pic.jpg'
import { useState, Fragment,useRef, useEffect } from 'react';
import { Avatar } from '../components/avatar'
import { useParams, useNavigate } from "react-router-dom";
import { SidebarLayoutNew } from '../components/sidebar-layout-new';
import { ErrorNotification, SuccessNotification } from '../components/notification';
import { DocumentPlusIcon, PlusIcon, PencilSquareIcon, UserPlusIcon } from '@heroicons/react/16/solid';
import { Footer } from '../components/footer';
import { Button } from '../components/button';
import { Text } from '../components/text'
import { Heading, Subheading } from '../components/heading';
import { ErrorMessage, Field, Label, Description, Fieldset, Legend } from '../components/fieldset';
import { Input } from '../components/input';
import { BreadcrumbsNew } from '../components/breadcrumbs'
import { PageInfo } from '../components/page-info'
import config from '../config.js'
//import { Listbox,ListboxOption } from '@headlessui/react';
import { Checkbox, CheckboxField, CheckboxGroup } from '../components/checkbox'
import { Listbox, ListboxLabel, ListboxOption } from '../components/listbox'
import { Loader } from '../components/loader';
import { useSession } from '../components/session-provider';
import { useAlert } from "../components/customAlert";
import ValidationErrors from "../components/validationErrors";

export default function AddUser() {
  const { showAlert } = useAlert();  
  const fileInputRef = useRef(null);
  const { session, setSession } = useSession();
  const current_userType = session.user_type;
  console.log('user_type : '+session.user_type);
  const [successMsg, setSuccessMsg] = useState('');
  const [showSuccessBox, setShowSuccessBox] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [showErrorBox, setShowErrorBox] = useState(false);  
  const { userid } = useParams();  
  const [companies, setCompanies] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const isEdit = !!userid;
  const [errors, setErrors] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const initialFormData = {
  name: "",
  email: "",
  mobile: "",
  user_type: "",
  companies_allowed: [],
};

const [formData, setFormData] = useState(initialFormData);
const [originalData, setOriginalData] = useState(initialFormData);//store for reset

let breadcrumbs_link = '';
let page_info = '';

if(isEdit){
   breadcrumbs_link = [{ name: "Manage Users", href: "/manage-users", current: false },{ name: "Edit User", href: "#", current: true }];
  page_info = `This section allows you to update user details`;
}else{ 
  breadcrumbs_link = [{ name: "Manage Users", href: "/manage-users", current: false },{ name: "Add New User", href: "#", current: true }];
  page_info = `This section allows you to create a new User`; 
}



  /*const companies = [
  { id: "comp1", name: "Anyahindmarch GB" },
  { id: "comp2", name: "Anyahindmarch US" },
  { id: "comp3", name: "Anyahindmarch AU" },
  { id: "comp4", name: "Anyahindmarch DE" },
  { id: "comp5", name: "Anyahindmarch FR" },
  { id: "comp6", name: "Anyahindmarch SG" }  
]*/

let userTypes = [];
if(current_userType==='sumo_admin'){
  userTypes = [
    { value: "", label: "-- Select --" },
    { value: "sumo_admin", label: "Sumo Admin" },
    { value: "sumo_user", label: "Sumo User" },
    { value: "merchant_admin", label: "Merchant Admin" },
    { value: "merchant_user", label: "Merchant User" },
    { value: "agency_admin", label: "Agency Admin" },
    { value: "agency_user", label: "Agency User" },
  ];
}else if(current_userType==='agency_admin'){
  userTypes = [
    { value: "", label: "-- Select --" },    
    { value: "agency_user", label: "Agency User" },
  ];
}else if(current_userType==='merchant_admin'){
   userTypes = [
    { value: "", label: "-- Select --" },    
    { value: "merchant_user", label: "Merchant User" },    
  ];
}


  //Load data for edit mode
  useEffect(() => {
    if (isEdit) {
      fetch(`${config.apiPath}/account-setup/account-handler.php?process=get_user_details&user_id=${userid}`)
        .then((res) => res.json())
        .then((data) => {
          const userData = {
          name: data.display_name,
          email: data.email_address,
          mobile: data.mobile_number,
          user_type: data.user_type,
          companies_allowed: data.company_access || [],
        };
        setFormData(userData);
        setOriginalData(userData);
        });
    }
  }, [isEdit, userid]);

  useEffect(() => {
    fetchCompanies();
  }, []);

  // Fetch paginated product data
  const fetchCompanies = async () => {
	  setLoading(true); // show loader	 
	   try {
			const res = await fetch(`${config.apiPath}/account-setup/account-handler.php?process=get_companies`,{ credentials: 'include' });
			const data = await res.json();
			setCompanies(data.companies);			
	   }catch(error){
		   console.error("Fetch error", error);
	   } finally {
    		setLoading(false); // hide loader
  		}
  };

   const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCancel = () => {
    if (isEdit) {
    setFormData(originalData); // reset to fetched user data
  } else {
    setFormData(initialFormData); // reset to blank form
  }
  setErrors({}); // clear validation errors
};

const validate = () => {
  let errors = {};

  if (!formData.name.trim()) errors.name = "Name is required";
  if (!formData.email.trim()) {
    errors.email = "Email is required";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    errors.email = "Invalid email format";
  }
  if (!formData.mobile.trim()) errors.mobile = "Mobile is required";
  if (!formData.user_type) errors.type = "User type is required";
  if (formData.companies_allowed.length === 0)
    errors.companies_allowed = "At least one company must be selected";

  setErrors(errors);
  return Object.keys(errors).length === 0;
};

const handleCompanyChange = (checked, companyId) => {
  setFormData((prev) => ({
    ...prev,
    companies_allowed: checked
      ? [...prev.companies_allowed, companyId]
      : prev.companies_allowed.filter((id) => id !== companyId),
  }));
};

const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      console.log("Selected:", file);

      //show preview immediately
      const previewUrl = URL.createObjectURL(file);
      setFormData({ ...formData, profile_picture: previewUrl });
    }
  };
     
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      const url = isEdit ? `${config.apiPath}/account-setup/account-handler.php?process=update_sub_user&user_id=${userid}` : `${config.apiPath}/account-setup/account-handler.php?process=add_sub_user`;
      const method = "POST";

      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
        credentials: 'include' 
      });

      const data = await res.json();

      if (data.status==='success') {
        showAlert(data.msg, "" , "success",3000); 
        navigate("/manage-users"); // redirect after save                
      }else{
        showAlert(data.msg, "" , "error",3000);         
      }
    }
  };  	  

  return (
    <Fragment>
      <SidebarLayoutNew selected_menu="addnewcompany">
	    <SuccessNotification showSuccessBox={showSuccessBox} successMsg={successMsg} setShowSuccessBox={setShowSuccessBox} />
      <ErrorNotification showErrorBox={showErrorBox} errorMsg={errorMsg} setShowErrorBox={setShowErrorBox} />
	    <BreadcrumbsNew pages={breadcrumbs_link} />
      
      <div className="flex w-full items-center gap-3 rounded-lg !pl-0 px-2 py-2.5 text-left text-base/4 font-medium text-zinc-950 sm:py-2 sm:text-sm/4 *:data-[slot=icon]:size-6 *:data-[slot=icon]:shrink-0 *:data-[slot=icon]:fill-zinc-500 sm:*:data-[slot=icon]:size-5 *:last:data-[slot=icon]:ml-auto *:last:data-[slot=icon]:size-5 sm:*:last:data-[slot=icon]:size-4 *:data-[slot=avatar]:-m-0.5 *:data-[slot=avatar]:size-7 sm:*:data-[slot=avatar]:size-6 data-hover:bg-zinc-950/5 data-hover:*:data-[slot=icon]:fill-zinc-950 data-active:bg-zinc-950/5 data-active:*:data-[slot=icon]:fill-zinc-950 data-current:*:data-[slot=icon]:fill-zinc-950 dark:text-white dark:*:data-[slot=icon]:fill-zinc-400 dark:data-hover:bg-white/5 dark:data-hover:*:data-[slot=icon]:fill-white dark:data-active:bg-white/5 dark:data-active:*:data-[slot=icon]:fill-white dark:data-current:*:data-[slot=icon]:fill-white">
		    {isEdit ? <PencilSquareIcon className="!size-8" /> : <UserPlusIcon className="!size-8" />}
		    <Heading>{isEdit ? "Edit User" : "Add New User"}</Heading>
	    </div>

      <PageInfo info={page_info} />

      <div className="w-full">
			{Object.values(errors).length > 0 && (
				<ValidationErrors 
				title="There were some errors with your submission" 
				errors={Object.values(errors)} 
				/>
			)}
		  </div>

      {loading ? (
            <Loader />
          ) : (
      
      <form onSubmit={handleSubmit} noValidate className="mx-auto max-w-6xl">
      <section className="space-y-6">
        <div className="grid grid-cols-2 gap-x-8 mt-4">                
          <Field>
            <Subheading>Name</Subheading>
            <Input id="name"  name="name"  value={formData.name}  onChange={handleChange} type="text" invalid={!!errors.name} />
            {/*formErrors.name && (<ErrorMessage>{formErrors.name}</ErrorMessage>)*/}             
          </Field> 			     
                  
          <Field>
            <Subheading>Email</Subheading>
            <Input id="email"  name="email"  value={formData.email}  onChange={handleChange} type="text" invalid={!!errors.email} />				  
            {/*formErrors.email && (<ErrorMessage>{formErrors.email}</ErrorMessage>)*/}             
          </Field>
        </div>
      </section>

      <section className="space-y-6"> 
			  <div className="grid grid-cols-2 gap-x-8 mt-4">   
          <Field>
            <Subheading>Mobile</Subheading>
            <Input id="mobile"  name="mobile"  value={formData.mobile}  onChange={handleChange} type="text" invalid={!!errors.mobile} />
            {/*formErrors.mobile && (<ErrorMessage>{formErrors.mobile}</ErrorMessage>)*/}             
          </Field>       
                  
          <Field>	
            <Subheading>User Type</Subheading>	    
            <Listbox name="user_type"
                  value={formData.user_type}  
                  onChange={(val) => setFormData({ ...formData, user_type: val })}
                  invalid={!!errors.type}
                >
                {userTypes.map((opt) => (
                  <ListboxOption key={opt.value} value={opt.value}>
                    <ListboxLabel>{opt.label}</ListboxLabel>
                  </ListboxOption>
                ))}
              </Listbox>
            {/*formErrors.type && (<ErrorMessage>{formErrors.type}</ErrorMessage>)*/}             
          </Field>
        </div>
      </section>
      
      <section className="space-y-6 mt-4">                 
          <Field>
            <Subheading>Company Access</Subheading>
            <div className={`border ${errors.companies_allowed ? 'border-red-500' : 'border-gray-300'} rounded-lg`}>
            <div className={`max-h-30 mb-[10px] mt-1 overflow-x-auto overflow-y-auto p-[5px]`}> 
          <CheckboxGroup>
            <div className="grid grid-cols-4 gap-x-8 gap-y-2">
            {companies.map((c) => (
              <CheckboxField key={c.sumo_account_id}>
                <Checkbox
                  name="companies_allowed"
                  value={c.sumo_account_id}   
                  checked={formData.companies_allowed.includes(c.sumo_account_id)} // controlled state
                  onChange={(checked) => handleCompanyChange(checked, c.sumo_account_id)}             
                />
                <Label>{c.account_name}</Label>
              </CheckboxField>
            ))}
            </div>
          </CheckboxGroup>          
          </div>
          </div>
          {/*formErrors.companies_allowed && (
            <ErrorMessage>{formErrors.companies_allowed}</ErrorMessage>
          )*/}          
        </Field>      
      </section>          
      
      {/* <div className="flex justify-start gap-4 mt-4"> 
        <Field> 
            <Subheading>Profile Picture</Subheading>          
            
            <input
          id="file"
          name="file"
          type="file"
          accept="image/*"
          className="hidden"
          ref={fileInputRef}
          onChange={handleFileChange}
        />
            <Avatar
          square
          className="!size-20 overflow-hidden cursor-pointer [&>img]:w-full [&>img]:h-full [&>img]:object-cover"
          src={isEdit ? formData.profile_picture : default_profile_pic}
          onClick={() => fileInputRef.current?.click()}
        />            
        {formErrors.profile_pic && (<ErrorMessage>{formErrors.profile_pic}</ErrorMessage>)} 
        </Field>
       </div> */}
      
      <div className="flex justify-end gap-4 mt-4">
        <Button type="reset" onClick={handleCancel} outline>
          Cancel
        </Button>
        <Button type="submit">{isEdit ? "Update User" : "Add User"}</Button>
      </div> 
     

      </form>
          )}
      
      </SidebarLayoutNew>
      <Footer />
    </Fragment>
  );
}
